<template lang="pug">
v-container
  v-progress-linear(v-if="loading" indeterminate)
  v-row(v-else)
    v-col(cols="12")
      h1 Мои муниципалитеты {{municipalities}}
    v-col(cols="12")
      v-card(outlined).pt-2
        smart-table(
          :adapter="adapter"
          :headers="headers"
          :needToUpdateTable="needToUpdateTable"
          :customOrder="customOrder"
        )
          template(#value--email_setting_is_active="{ item }")
            v-chip(outlined :color="item.email_setting_is_active ? 'success': ''")
              v-icon.mr-2 {{ item.email_setting_is_active ? 'mdi-check' : 'mdi-close' }}
              p.mt-4 {{ item.email_setting_is_active ? 'Почта настроена' : 'Почта не настроена' }}

</template>
<script>
import SmartTable from '@/components/SmartTable/index.vue';
import { getMunicipalities } from '@/services/API/_common';
import { mapGetters } from 'vuex';

export default {
  components:{
    SmartTable,
  },
  data() {
    return {
      needToUpdateTable: true,
      loading: true,
      headers: [
        {
          text: 'Наименование',
          value: 'name',
          sortable: true,
          searchable: true,
        },
        {
          text: 'Готовность почты',
          value: 'email_setting_is_active',
          sortable: true,
          searchable: true,
        },
      ],
    };
  },
  computed:{
    ...mapGetters({
      'user':'auth/getUser',
    }),
  },
  created() {
    this.init();
  },
  methods:{
    init() {
      this.needToUpdateTable = true;
      this.loading = false;
    },
    customOrder(sort) {
      return Object.keys(sort).reduce((acc, value) => {
        // console.log(value, 2);
        if (value === 'email_setting_is_active') {
          if (sort[value] === 'DESC') acc.custom_sort = `${value}`;
          if (sort[value] === 'ASC') acc.custom_sort = `-${value}`;
        } else {
          if (sort[value] === 'DESC') acc.sort = `${value}`;
          if (sort[value] === 'ASC') acc.sort = `-${value}`;
        }
        return acc;
      }, {});
    },
    async adapter({ _update, ...options }) {
      this.needToUpdateTable = false;
      const params = {
        'per-page': options.itemsPerPage,
        'search[region_id]': this.user.region_id,
        ...options,
      };
      const response = await getMunicipalities(params);
      return new Promise((resolve) => resolve(response));
    },
  },
};
</script>

<style>

</style>
